module.exports = __webpack_public_path__ + "img/little1.a19af5cb.webp";